import React from 'react'
import BaseOperatorForm from './BaseOperatorForm'

export default function CreateChppOperatorForm(props) {
  return <BaseOperatorForm {...props} locationKey="chpp" locationLabel="ТЭЦ"
    createOperator={props.createChppOperator} loadOperators={props.loadChppOperators} />
}
